/**
 * @typedef {{
 *  useGrouping?: boolean; // Controls whether or not to separate number groups
 *  minimumFractionDigits?: number; // Pads the decimal place with 0's to guarantee X decimal places
 *  maximumFractionDigits?: number; // Rounds to the specified decimal place if there are too many decimal places
 *  minimumIntegerDigits?: number; // Will add 0's to the front of the integers until there are X integer places (eg 3 would make "7" be "007")
 * }} NumberFormatOptions
 */

/**
 * A wrapper around the Intl.NumberFormat library to provide our defaults.
 * For more information see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
 *
 * @param {number|string} number - The value to be formatted
 * @param {string | NumberFormatOptions} [locale='en'] - The locale to use for formatting(we usually use 'en' or 'de')
 * @param {NumberFormatOptions} options The options to pass to the formatter.  See: https://www.javascripture.com/NumberFormat for a complete list of available options.  Below are our common options
 * @returns {string} - Formatted number
 */
export default (number, locale = 'en', options = { useGrouping: true }) => {
    // Check to see if locale was omitted and replaced with options
    if (typeof locale !== 'string') {
        options = locale;
        locale = 'en';
    }

    return Intl.NumberFormat(locale, options).format(number);
};
